import { render, staticRenderFns } from "./DatesUpdateModal.vue?vue&type=template&id=7b45946a"
import script from "./DatesUpdateModal.vue?vue&type=script&lang=ts"
export * from "./DatesUpdateModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports